// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.keys-container-pdf {
  width: 98%;
  margin-left: 1%;
  background-color: #F4F7F9;
  border-radius: 1cm;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 0.5cm;
}
.keys-container-pdf__title {
  width: 100%;
  font-size: 0.5cm;
  font-weight: 700;
  display: flex;
  justify-content: flex-start;
  padding: 0.3cm 0 0 0.5cm;
}
.keys-container-pdf__data {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.keys-container-pdf__data__data-date {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  color: white;
  font-size: 0.35cm;
  width: 4.5cm;
  height: 0.7cm;
  border-radius: 0.5cm;
  margin-left: 0.5cm;
}
.keys-container-pdf__data__keys {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 70%;
  margin-left: 4cm;
}
.keys-container-pdf__data__keys__one {
  display: flex;
  flex-direction: column;
}
.keys-container-pdf__data__keys__one__title {
  margin-bottom: 0.3cm;
  max-width: 2.5cm;
  height: 1.5cm;
  text-wrap: wrap;
  font-size: 0.4cm;
}
.keys-container-pdf__data__keys__one__value {
  font-size: 0.45cm;
  color: #EF936C;
}
.keys-container-pdf__disclaimer {
  font-size: 0.3cm;
  font-weight: 400;
  text-align: left;
  padding: 0.3cm 0.3cm 0 0.5cm;
  margin-bottom: 0.5cm;
}`, "",{"version":3,"sources":["webpack://./src/features/pdf/components/keys-container-pdf/keys-container-pdf.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iBAAA;AACJ;AAAI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,wBAAA;AAER;AAAI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;AAER;AADQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;AAGZ;AADQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;AAGZ;AAFY;EACI,aAAA;EACA,sBAAA;AAIhB;AAHgB;EACI,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAKpB;AAHgB;EACI,iBAAA;EACA,cAAA;AAKpB;AAAI;EACI,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;AAER","sourcesContent":[".keys-container-pdf{\n    width: 98%;\n    margin-left: 1%;\n    background-color: #F4F7F9;\n    border-radius: 1cm;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin-top: 0.5cm;\n    &__title{\n        width: 100%;\n        font-size: 0.5cm;\n        font-weight: 700;\n        display: flex;\n        justify-content: flex-start;\n        padding: 0.3cm 0 0 0.5cm;\n    }\n    &__data{\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        &__data-date{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: black;\n            color: white;\n            font-size: 0.35cm;\n            width: 4.5cm;\n            height: 0.7cm;\n            border-radius: 0.5cm;\n            margin-left: 0.5cm;\n        }\n        &__keys{\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-evenly;\n            width: 70%;\n            margin-left: 4cm;\n            &__one{\n                display: flex;\n                flex-direction: column;\n                &__title{\n                    margin-bottom: 0.3cm;\n                    max-width: 2.5cm;\n                    height: 1.5cm;\n                    text-wrap: wrap;\n                    font-size: 0.4cm;\n                }\n                &__value{\n                    font-size: 0.45cm;\n                    color:#EF936C;\n                }\n            }\n        }\n    }\n    &__disclaimer{\n        font-size: 0.3cm;\n        font-weight: 400;\n        text-align: left;\n        padding: 0.3cm 0.3cm 0 0.5cm;\n        margin-bottom: 0.5cm;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
